import { ComponentType, SVGProps } from "react";

import classNames from "../../utils/classNames";

export enum StatusPillColour {
  Neutral,
  Blue,
  Green,
  Yellow,
  Orange,
  Red,
  Purple,
}

interface StatusPillProps {
  text: string;
  colour: StatusPillColour;
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
}

export default function StatusPill({ text, colour, icon: Icon }: StatusPillProps) {
  const colourClasses = getColourClasses(colour);

  return (
    <span
      className={classNames(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium",
        colourClasses
      )}
    >
      {Icon ? <Icon className="h-3.5 w-3.5" /> : null}
      {text}
    </span>
  );
}

function getColourClasses(colour: StatusPillColour): string {
  switch (colour) {
    case StatusPillColour.Blue:
      return "bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-200";
    case StatusPillColour.Green:
      return "bg-green-50 text-green-700 ring-1 ring-inset ring-green-200";
    case StatusPillColour.Yellow:
      return "bg-yellow-50 text-yellow-700 ring-1 ring-inset ring-yellow-200";
    case StatusPillColour.Orange:
      return "bg-orange-50 text-orange-700 ring-1 ring-inset ring-orange-200";
    case StatusPillColour.Red:
      return "bg-red-50 text-red-700 ring-1 ring-inset ring-red-200";
    case StatusPillColour.Purple:
      return "bg-purple-50 text-purple-700 ring-1 ring-inset ring-purple-200";
    case StatusPillColour.Neutral:
    default:
      return "bg-gray-50 text-gray-700 ring-1 ring-inset ring-gray-200";
  }
}
